module.exports = __webpack_public_path__ + "img/by.86116f29.svg";